'use client';

import {
  ErrorBoundaryBase,
  ErrorBoundaryDefaultProps,
} from '@/components/utils/ErrorBoundaryBase';

export default function PublicError({
  error,
  reset,
}: ErrorBoundaryDefaultProps) {
  return (
    <ErrorBoundaryBase error={error} reset={reset} errorHint="[PublicError]" />
  );
}
